import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleAim = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20 24C22.2091 24 24 22.2091 24 20C24 17.7909 22.2091 16 20 16C17.7909 16 16 17.7909 16 20C16 22.2091 17.7909 24 20 24Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 29.7999C13.193 28.8788 11.6759 27.4759 10.6163 25.7464C9.55674 24.017 8.99597 22.0282 8.99597 20C8.99597 17.9717 9.55674 15.983 10.6163 14.2535C11.6759 12.524 13.193 11.1211 15 10.2",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 10.2C26.807 11.1211 28.3241 12.524 29.3837 14.2535C30.4432 15.983 31.004 17.9717 31.004 20C31.004 22.0282 30.4432 24.017 29.3837 25.7464C28.3241 27.4759 26.807 28.8788 25 29.7999",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgCircleAim);
export default ForwardRef;
